import React from 'react';
import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  Text,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

const TheContextInvestingBlog: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '400px', lg: '400px' }}
      maxH={{ xs: '400px', lg: '400px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            Quantitative Investing: A Systematic Revolution In Markets
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Praveen Kumar
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Piyush Gupta
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Authors
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          {[
            {
              name: 'Praveen Kumar',
              position:
                'Chief Investment Officer, AlphaGrep Investment Management',
              image:
                'https://static.levocdn.com/WGLBUT82/Praveen-R6erN5adsAUB.jpeg',
              linkedIn:
                'https://www.linkedin.com/in/praveen-kumar-16b68426/?originalSubdomain=in',
            },
            {
              name: 'Piyush Gupta',
              position: 'Fund Manager for AlphaGrep Investment Management IFSC',
              image:
                'https://static.levocdn.com/WGLBUT82/Piyush-ZnM7UQVHoJHV.jpg',
              linkedIn:
                'https://www.linkedin.com/in/piyush-gupta-cfa-575ba917/?originalSubdomain=in',
            },
          ].map((item, index) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              <Flex
                key={index}
                flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
                columnGap="20px"
                rowGap="16px"
              >
                <Flex
                  flexDir="column"
                  alignItems={{ xs: 'center', sm: 'flex-start' }}
                  rowGap="8px"
                >
                  <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                    <Avatar
                      name={item.name}
                      w="100%"
                      h="100%"
                      src={item.image}
                      objectFit="cover"
                    />
                  </Box>
                  <Flex flexDir="column" rowGap="4px">
                    <Flex
                      alignItems="center"
                      gap="12px"
                      justifyContent={{ xs: 'center', md: 'start' }}
                    >
                      <Heading
                        variant="blogQuestion"
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        {item.name}
                      </Heading>
                      <Link href={item?.linkedIn} target="_blank">
                        <IconButton
                          aria-label="linkedin"
                          icon={<FaLinkedin size="28px" color="#067acc" />}
                          variant="unstyled"
                          cursor="pointer"
                        />
                      </Link>
                    </Flex>
                    <Text
                      variant="blogAnswer"
                      textAlign={{ xs: 'center', sm: 'left' }}
                      fontStyle="italic"
                    >
                      {item.position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ))}
        </Flex>
        <Flex flexDirection="column" w="100%">
          <Box>
            <Text variant="blogAnswer" mb="20px">
              Quantitative investing has reshaped global financial markets,
              expanding far beyond equities into fixed income, commodities,
              forex, and even private equity. Today, quant-driven funds account
              for approximately 35% of the total U.S. market capitalization—over
              $2 trillion. These strategies thrive in markets where vast
              datasets and pricing inefficiencies create opportunities for
              systematic models. In commodities and forex markets,
              high-frequency trading (HFT) firms execute thousands of trades per
              second, exploiting millisecond-level price discrepancies. Even in
              private equity and venture capital, quant models are increasingly
              being used to evaluate deals and optimize portfolios.
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              What is Quant Investing?
            </Text>

            <Text variant="blogAnswer" mt="16px">
              The definition of quant investing varies depending on who you ask.
              However, a quote from The Man Who Solved the Market—a biography of
              Jim Simons, the pioneer of quantitative investing—captures its
              essence: <br />
              "Historic patterns can form the basis of computer models capable
              of identifying overlooked and ongoing market trends, allowing one
              to divine the future from the past." <br /> <br />
              At its core, quantitative investing leverages mathematical models
              and algorithms to systematically analyze massive amounts of
              historical data, identifying patterns and signals that can be used
              to predict market movements. Unlike traditional investing, which
              is often influenced by human emotions, quant strategies operate
              based on predefined rules, ensuring a disciplined, objective, and
              repeatable investment process. This systematic approach aims to
              generate superior risk-adjusted returns.
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              The Growth of Quant Investing in India
            </Text>

            <Text variant="blogAnswer" mt="16px">
              In India, quantitative investing is still in its early stages.
              However, investor interest has surged, with quant-based funds
              growing over 100x in last 5 years. Historically, the biggest
              challenge in building a robust quant ecosystem was the
              availability and quality of market data. Inaccurate or incomplete
              data leads to unreliable models, making it difficult for quants to
              extract meaningful signals. Fortunately, the quality of financial
              data in India has significantly improved in recent years, paving
              the way for more sophisticated systematic strategies. <br />{' '}
              <br />
              Another major driver of quant adoption is technological
              advancement. Computing power has become more accessible and
              cost-effective, enabling firms to process vast amounts of data and
              run complex models in real time. At Alphagrep, we prioritize
              cutting-edge technology and high-quality data management, ensuring
              our models are both accurate and efficient. Our focus on
              best-in-class infrastructure and state-of-the-art systems allows
              us to remain at the forefront of quantitative finance in India.
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Challenges and Limitations of Quant Investing
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Despite its advantages, quant investing is not without challenges.
              While algorithms eliminate human emotions from trade execution,
              emotions still play a role in model development. Cognitive biases
              can creep into the research process, leading to flawed models.
              Overfitting—where a strategy performs well in back-tests but fails
              in live markets—is a common pitfall. Many quant strategies appear
              highly profitable in simulations but fail under real-world market
              conditions due to excessive curve-fitting. <br /> <br />
              To mitigate these risks, a robust research framework and
              disciplined risk management are essential. At Alphagrep, our team
              of highly skilled professionals ensures rigorous back-testing and
              validation processes, designing models that are resilient across
              different market regimes. Risk management remains a core pillar of
              our approach, preventing excessive drawdowns and improving
              long-term performance.
            </Text>
          </Box>

          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Conclusion
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Quantitative investing is transforming global markets, offering a
              systematic, data-driven approach that minimizes emotional biases
              and enhances decision-making. While still in its early stages in
              India, the rapid advancements in data quality, technology, and
              investor awareness are accelerating its adoption. However, success
              in quant investing requires more than just superior technology—it
              demands meticulous research, strong risk controls, and constant
              adaptation to evolving market conditions.
            </Text>
          </Box>
        </Flex>
      </Flex>

      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default TheContextInvestingBlog;
